import { Helmet } from "react-helmet";

import DailyLivingImage from "../assets/images/DailyLiving.svg";

const DailyLiving = () => {
  return (
    <main>
      <Helmet>
        <title>Support with Daily Living | Provido</title>
        <meta
          property="og:title"
          content="Support with Daily Living | Provido"
        />
        <meta
          name="description"
          content="We provide support to help people with their day-to-day activities and tasks."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/support-with-daily-living"
        />
        <meta
          name="twitter:title"
          content="Support with Daily Living | Provido"
        />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mx-12 grid grid-cols-1 gap-8 sm:grid-cols-3 lg:gap-24">
          <div className="order-2 col-span-1 flex items-center lg:order-1 lg:-my-20">
            <img
              src={DailyLivingImage}
              className="-mt-6 max-h-112 w-full pb-6"
              alt="Illustration: a man helping a woman with a walking stick carry her shopping."
            />
          </div>
          <div className="order-1 col-span-2 flex flex-col items-center pb-12 sm:order-2 sm:gap-8">
            <div className="pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
              Support with Daily Living
            </div>
            <p>
              Our Support with Daily Living services support participants to
              maintain their independence and confidently manage everyday tasks.
              <br />
              <br />
              We provide personalised support tailored to each participant’s
              needs, goals, and routines, helping them build skills, maintain
              wellbeing, and live as independently as possible in their home and
              community.
            </p>
          </div>
        </div>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <div className="mx-auto w-fit">
          <div className="flex flex-col justify-center">
            <h2 className="pb-12 text-center font-display text-4xl text-purple">
              How We Can Help You
            </h2>
            <h3 className="pb-1 font-display text-xl text-blue">
              Our Support with Daily Living services may assist with:
            </h3>
            <ul className="text-list">
              <li>Personal care and hygiene</li>
              <li>Showering and grooming</li>
              <li>Dressing and getting ready for the day</li>
              <li>Meal preparation and nutrition support</li>
              <li>Household tasks and cleaning</li>
              <li>Laundry and linen changes</li>
              <li>Medication reminders and support</li>
              <li>Shopping and essential errands</li>
              <li>Developing daily living skills</li>
              <li>Establishing routines and building independence</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-3xl text-blue lg:text-4xl">
            Who We Support?
          </h2>
          <p>
            We support participants living with a wide range of disabilities and
            support needs, including:
          </p>
          <ul className="text-list">
            <li>Intellectual disabilities</li>
            <li>Autism Spectrum Disorder (ASD)</li>
            <li>Physical disabilities</li>
            <li>Neurological conditions</li>
            <li>Psychosocial disabilities</li>
          </ul>
          <p>
            We are committed to helping participants maintain their
            independence, achieve their goals, and enjoy a greater quality of
            life.
          </p>
        </div>
      </div>
    </main>
  );
};

export default DailyLiving;
